export const apiFetch = (url, options = {}) => {
  const token = localStorage.getItem("corelia_token");

  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};